import PageRouted from "./pageRouted";

//import "@/styles/globals.scss";

export default function UnAuthorized() {
  return <PageRouted />;
}
